import { register } from '../../../JavaScript/Utils'

const ImageGallery = el => {
  const init = () => {
    const Splide = window.Splide
    const sliderContainer = el.querySelector('.splide-wrapper')

    const imageSlider = new Splide(sliderContainer, {
      type: 'loop',
      autoHeight: el.dataset.autoHeight === 'true' || true,
      autoplay: el.dataset.autoplay || false,
      classes: {
        pagination: 'splide__pagination pagination',
        page: 'splide__pagination__page page-bubble cursor-pointer'
      }
    })

    imageSlider.mount()
  }

  init()
}

register('ImageGallery', ImageGallery)
